<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <garage-create-or-update v-model="garage" :errors="errors"></garage-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="garage"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import GarageCreateOrUpdate from './components/GarageCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        GarageCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            garage:{
                Id:0,
                GarageName:null,
                BranchId:null,
                EmployeeId:null,
                EmployeeFullName:null,
            },
            fields:[
                { name:"Şube Adı",key:"BranchName", thClass:"w-25",sortable:true,sortKey:"Province.Name"},
                { name:"İl",key:"ProvinceName", thClass:"w-17",sortable:true,sortKey:"Province.Name"},
                { name:"İlçe",key:"DistrictName", thClass:"w-18",sortable:true,sortKey:"District.Name"},
                { name:"Garaj",key:"GarageName", thClass:"w-20",sortable:true,},
                { name:"Puantaj Sorumlusu",key:"EmployeeFullName", thClass:"w-20",sortable:true,},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.garage.Id = 0
            this.garage.GarageName = null
            this.garage.BranchId = null
            this.garage.EmployeeFullName = null
            this.garage.EmployeeId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.garage.Id = item.Id
            this.garage.GarageName = item.GarageName
            this.garage.BranchId = item.BranchId
            this.garage.EmployeeId = item.EmployeeId
            this.garage.EmployeeFullName = item.EmployeeFullName
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            VehicleOperationsApi.Garage.CreateOrUpdate(this.editing,this.garage)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return VehicleOperationsApi.Garage.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.GarageName} garajını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleOperationsApi.Garage.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>